<template lang="pug">
  tr.row.row-title
    th.col.sort
      a(@click="sort")
        span 絞り込み・並び替え
    th.col(v-for="v in columns", v-if="displayedColumns.includes(v.key)", :class="v.key")
      span {{ v.label }}
</template>

<script>
  import { mapMutations, mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        columns: state => state.corporationTableConfiguration.columns,
        displayedColumns: state => state.corporationTableConfiguration.displayedColumns,
      }),
    },
    methods: {
      ...mapMutations('corporationTableConfiguration', ['sort']),
      check (event) {
        this.$emit('check', { event })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CorporationTableHeader.vue